import React, { useState } from 'react';
import { Search, Clock, Users, Star, Filter, ChefHat } from 'lucide-react';

import bowl from '../assets/images/productos/recetario/bowl-granola.jpg';
import mixEnergetico from '../assets/images/productos/recetario/mix-energetico-.jpg';
import aguaJamaica from '../assets/images/productos/recetario/jamaica.jpg';
import polloCiruelas from '../assets/images/productos/recetario/pollociruela.jpg';
import ensaladaAntioxidante from '../assets/images/productos/recetario/ensalada-frut.jpg';
import frijolesRefritos from '../assets/images/productos/recetario/Frijoles-refri.jpg';
import ia from '../assets/images/productos/recetario/Whisk_bc74b70d04.jpg'; 
import smootie from '../assets/images/productos/recetario/batido-verde.jpg';
// Pounch

import almendraEmp from '../assets/images/productos/empaquetado/almendra.png';
import arandanoEmp from '../assets/images/productos/empaquetado/arandano.png';
import canelaEmp from '../assets/images/productos/empaquetado/canela.png';
import chileArbolEmp from '../assets/images/productos/empaquetado/chileArbol.png';
import ciruelaPasaEmp from '../assets/images/productos/empaquetado/ciruelaPasa.png';
import frutoSecosEmp from '../assets/images/productos/empaquetado/frutoSecos.png';
import granolaEmp from '../assets/images/productos/empaquetado/granola.png';
import jamaicaEmp from '../assets/images/productos/empaquetado/jamaica.png';
import nuezEmp from '../assets/images/productos/empaquetado/nuez.png';
import uvaPasaEmp from '../assets/images/productos/empaquetado/uvaPasa.png';
import frijolesBayosImg from '../assets/images/productos/PR/FRIJOLES_BAYOS_ANVERSO.png';


const RecetarioGourmet = () => {
  const [filtroCategoria, setFiltroCategoria] = useState('Todas');
  const [busqueda, setBusqueda] = useState('');
  const [recetaSeleccionada, setRecetaSeleccionada] = useState(null);


const recetasSaludables = [
  {
    id: 1,
    nombre: "Bowl de Granola Superfood",
    categoria: "Desayuno",
    tiempo: "10 min",
    porciones: 2,
    dificultad: "Fácil",
    rating: 4.9,
    imagen: "🥣",
    imagenSrc: bowl,
    productoEmpSrc: [granolaEmp, arandanoEmp, almendraEmp ],
    ingredientes: [
      "1 bolsa de granola Campo Fresco sin azúcar añadido",
      "1 bolsa de arándanos Campo Fresco frescos o congelados",
      "1 bolsa de almendras Campo Fresco crudas troceadas",
      "Yogur griego natural sin azúcar",
      "1 cucharada de miel cruda o jarabe de maple"
    ],
    preparacion: [
      "Sirve la granola en el bowl como base",
      "Añade una porción generosa de yogur griego natural",
      "Decora con los arándanos y almendras",
      "Rocía ligeramente con miel cruda",
      "Disfruta inmediatamente"
    ],
    tips: "Rico en probióticos, antioxidantes y grasas saludables",
    beneficios: "Aporta fibra, proteína y energía sostenida para toda la mañana"
  },

  {
    id: 3,
    nombre: "Agua de Jamaica Detox",
    categoria: "Bebida",
    tiempo: "15 min",
    porciones: 4,
    dificultad: "Fácil",
    rating: 4.7,
    imagen: "🌺",
    imagenSrc: aguaJamaica,
    productoEmpSrc: [jamaicaEmp, canelaEmp],
    ingredientes: [
      "1 bolsa de flor de jamaica Campo Fresco orgánica",
      "1 rama de canela Campo Fresco",
      "Rodajas de jengibre fresco",
      "Stevia natural o miel (opcional)",
      "Agua purificada"
    ],
    preparacion: [
      "Hierve el agua con la canela y jengibre",
      "Añade la jamaica y hierve 5 minutos",
      "Deja reposar 10 minutos",
      "Cuela y endulza mínimamente si es necesario",
      "Sirve frío con hielo"
    ],
    tips: "Antioxidante, diurético y libre de calorías",
    beneficios: "Ayuda a la hidratación y tiene propiedades antiinflamatorias"
  },
   {
    id: 2,
    nombre: "Mix Energético Natural",
    categoria: "Snack",
    tiempo: "5 min",
    porciones: 4,
    dificultad: "Muy Fácil",
    rating: 4.8,
    imagen: "🥜",
    imagenSrc: mixEnergetico,
    productoEmpSrc: [nuezEmp, canelaEmp, ciruelaPasaEmp, frutoSecosEmp],
    ingredientes: [
      "1 bolsa de nueces Campo Fresco mixtas crudas (sin sal)",
      "1 bolsa de pasas Campo Fresco sin azúcar añadido",
      "1 bolsa de semillas de girasol o calabaza",
      "Pizca de cúrcuma en polvo",
      "Pizca de canela Campo Fresco"
    ],
    preparacion: [
      "Mezcla todos los frutos secos y semillas",
      "Espolvorea las especias",
      "Guarda en recipiente hermético",
      "Consume una porción pequeña como snack"
    ],
    tips: "Fuente de omega-3, vitamina E y minerales esenciales",
    beneficios: "Perfecto para energía entre comidas sin picos de azúcar"
  },
  {
    id: 4,
    nombre: "Pollo con Ciruelas y Especias",
    categoria: "Plato Principal",
    tiempo: "45 min",
    porciones: 6,
    dificultad: "Intermedio",
    rating: 4.6,
    imagen: "🍗",
    imagenSrc: polloCiruelas,
    productoEmpSrc: [ciruelaPasaEmp],
    ingredientes: [
      "1 kg de pechuga de pollo orgánico",
      "1 bolsa de ciruelas pasas Campo Fresco sin azúcar",
      "Cebolla morada",
      "Ajo fresco",
      "Cúrcuma, comino, pimienta negra",
      "Aceite de oliva extra virgen",
      "Vinagre de manzana"
    ],
    preparacion: [
      "Remoja las ciruelas en agua tibia",
      "Sofríe cebolla y ajo con poco aceite de oliva",
      "Sella el pollo con las especias",
      "Añade las ciruelas y un poco de su agua",
      "Cocina a fuego bajo hasta que esté tierno",
      "Sazona con hierbas frescas"
    ],
    tips: "Alto en proteína, bajo en grasas saturadas",
    beneficios: "Proteína completa con antioxidantes naturales de las especias"
  },
  {
    id: 5,
    nombre: "Ensalada Antioxidante",
    categoria: "Ensalada",
    tiempo: "20 min",
    porciones: 4,
    dificultad: "Fácil",
    rating: 4.8,
    imagen: "🥗",
    imagenSrc: ensaladaAntioxidante,
    productoEmpSrc: [arandanoEmp, nuezEmp, ],
    ingredientes: [
      "1 bolsa de mezcla de hojas verdes orgánicas",
      "1 bolsa de nueces Campo Fresco crudas",
      "1 bolsa de arándanos Campo Fresco frescos",
      "1 bolsa de semillas de chía",
      "Aguacate maduro",
      "Vinagreta de limón y aceite de oliva"
    ],
    preparacion: [
      "Lava bien las hojas verdes",
      "Tuesta ligeramente las nueces sin aceite",
      "Combina todos los ingredientes",
      "Prepara vinagreta con limón, aceite de oliva y hierbas",
      "Adereza justo antes de servir"
    ],
    tips: "Rica en fibra, omega-3 y vitaminas",
    beneficios: "Aporta grasas saludables y una gran variedad de micronutrientes"
  },

  {
    id: 7,
    nombre: "Frijoles Refritos Saludables",
    categoria: "Plato Principal",
    tiempo: "2 horas",
    porciones: 6,
    dificultad: "Fácil",
    rating: 4.6,
    imagen: "🌮",
    imagenSrc: frijolesRefritos,
    productoEmpSrc: [frijolesBayosImg, chileArbolEmp],
    ingredientes: [
      "1 bolsa de frijoles pintos Pueblo Rico orgánicos",
      "Cebolla blanca",
      "Ajo fresco",
      "Chiles secos Campo Fresco (al gusto)",
      "Aceite de oliva extra virgen (poco)",
      "Comino, sal de mar",
      "Caldo de verduras bajo en sodio"
    ],
    preparacion: [
      "Remoja los frijoles toda la noche",
      "Cocina con aromáticos hasta que estén suaves",
      "Sofríe cebolla y ajo con mínimo aceite",
      "Machaca los frijoles gradualmente",
      "Usa caldo en lugar de manteca",
      "Sazona con especias naturales"
    ],
    tips: "Alto en fibra y proteína vegetal, bajo en grasas saturadas",
    beneficios: "Excelente fuente de proteína vegetal y fibra soluble"
  },
  {
    id: 8,
    nombre: "Smoothie Verde Energizante",
    categoria: "Desayuno",
    tiempo: "10 min",
    porciones: 2,
    dificultad: "Fácil",
    rating: 4.7,
    imagen: "🥤",
    imagenSrc: smootie,
    productoEmpSrc: [almendraEmp, arandanoEmp],
    ingredientes: [
      "1 taza de espinacas frescas",
      "1/2 taza de arándanos Campo Fresco",
      "1 plátano maduro",
      "1 taza de leche de almendra Campo Fresco sin azúcar",
      "1 cucharadita de semillas de chía",
      "Hielo al gusto"
    ],
    preparacion: [
      "Coloca todos los ingredientes en la licuadora.",
      "Licúa a alta velocidad hasta obtener una mezcla suave.",
      "Prueba y ajusta la dulzura con stevia si es necesario.",
      "Sirve inmediatamente en vasos fríos."
    ],
    tips: "Añade proteína en polvo para un desayuno más completo.",
    beneficios: "Rico en antioxidantes, fibra y proteínas. Ideal para comenzar el día."
  },
  {
    id: 9,
    nombre: "Barritas Energéticas de Uva Pasa",
    categoria: "Snack",
    tiempo: "15 min",
    porciones: 8,
    dificultad: "Fácil",
    rating: 4.8,
    imagen: "🍇",
    imagenSrc: ia,
    productoEmpSrc: [uvaPasaEmp, nuezEmp, canelaEmp],
    ingredientes: [
      "1 taza de uva pasa Campo Fresco",
      "1 taza de avena integral",
      "1/2 taza de nuez Campo Fresco picada",
      "2 cucharadas de miel natural",
      "1 cucharadita de canela Campo Fresco en polvo"
    ],
    preparacion: [
      "Mezcla todos los ingredientes en un bowl hasta integrar bien.",
      "Coloca la mezcla en un molde forrado con papel encerado y presiona firmemente.",
      "Refrigera por al menos 1 hora.",
      "Corta en barritas y disfruta como snack saludable."
    ],
    tips: "Puedes agregar semillas de chía o linaza para más fibra.",
    beneficios: "Fuente natural de energía, fibra y antioxidantes. Ideal para lunch o colación."
  },
];

  const categorias = ['Todas', 'Desayuno', 'Snack', 'Bebida', 'Plato Principal', 'Ensalada', 'Postre'];

  const recetasFiltradas = recetasSaludables.filter(receta => {
    const coincideCategoria = filtroCategoria === 'Todas' || receta.categoria === filtroCategoria;
    const coincideBusqueda = receta.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
                           receta.ingredientes.some(ing => ing.toLowerCase().includes(busqueda.toLowerCase()));
    return coincideCategoria && coincideBusqueda;
  });

  const getDificultadColor = (dificultad) => {
    switch (dificultad) {
      case 'Muy Fácil': return 'text-green-600 bg-green-50';
      case 'Fácil': return 'text-blue-600 bg-blue-50';
      case 'Intermedio': return 'text-yellow-600 bg-yellow-50';
      case 'Difícil': return 'text-red-600 bg-red-50';
      default: return 'text-gray-600 bg-gray-50';
    }
  };

  if (recetaSeleccionada) {
    const receta = recetasSaludables.find(r => r.id === recetaSeleccionada);
    const productoImg = receta.productoEmpSrc;
    console.log(receta);
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50">
        <div className="container mx-auto px-4 py-8">
          <button 
            onClick={() => setRecetaSeleccionada(null)}
            className="mb-6 flex items-center gap-2 px-5 py-2 rounded-full bg-gradient-to-r from-orange-400 to-red-400 text-white font-semibold shadow-lg hover:from-orange-500 hover:to-red-500 hover:scale-105 transition-all border-2 border-white focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            ← Volver al recetario
          </button>
          
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
            <div
              className="relative h-64 flex items-end rounded-t-2xl overflow-hidden"
              style={{
                backgroundImage: `url(${receta.imagenSrc})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',

              }}
            >
              <div className="absolute inset-0 bg-black/40" />
              <div className="relative z-10 w-full px-8 pb-6">
                <h1 className="text-3xl font-bold text-white mb-2 drop-shadow-lg">{receta.nombre}</h1>
                <div className="flex flex-wrap items-center gap-4 text-orange-100 mb-2 drop-shadow">
                  <span className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    {receta.tiempo}
                  </span>
                  <span className="flex items-center gap-1">
                    <Users className="w-4 h-4" />
                    {receta.porciones} porciones
                  </span>
                  <span className="flex items-center gap-1">
                    <Star className="w-4 h-4 text-yellow-300" />
                    {receta.rating}
                  </span>
                </div>
                <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium bg-white/20 text-white drop-shadow`}>{receta.dificultad}</span>
              </div>
            </div>

            <div className="p-8">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                      <ChefHat className="w-6 h-6 text-orange-500" />
                      Ingredientes
                    </h2>
                  </div>
                  <ul className="space-y-2">
                    {receta.ingredientes.map((ingrediente, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <span className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></span>
                        <span className="text-gray-700">{ingrediente}</span>
                      </li>
                    ))}
                  </ul>
                  {/* Imagen de producto empaquetado justo debajo de los ingredientes */}
                  {productoImg && Array.isArray(productoImg) && productoImg.length > 0 && (
                    <div className="flex flex-col items-center gap-2 mt-4">
                      <div className="flex flex-row items-center gap-4">
                        {productoImg.map((img, idx) => (
                          <img key={idx} src={img} alt={receta.nombre + ' producto ' + (idx+1)} className="w-24 h-24 object-contain" />
                        ))}
                      </div>
                      <span className="inline-block mt-2 px-4 py-1 bg-orange-100 text-orange-800 rounded-full text-xs font-semibold tracking-wide shadow-sm">
                        Producto{productoImg.length > 1 ? 's' : ''} utilizado{productoImg.length > 1 ? 's' : ''}
                      </span>
                    </div>
                  )}
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">Preparación</h2>
                  <ol className="space-y-4">
                    {receta.preparacion.map((paso, index) => (
                      <li key={index} className="flex gap-3">
                        <span className="flex-shrink-0 w-8 h-8 bg-orange-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                          {index + 1}
                        </span>
                        <span className="text-gray-700 pt-1">{paso}</span>
                      </li>
                    ))}
                  </ol>
                </div>
              </div>

              {receta.tips && (
                <div className="mt-8 p-4 bg-amber-50 border-l-4 border-amber-400 rounded-r-lg">
                  <h3 className="font-semibold text-amber-800 mb-2">💡 Tip del Chef</h3>
                  <p className="text-amber-700">{receta.tips}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            🍽️ Recetario Gourmet
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Descubre deliciosas recetas creadas especialmente para nuestros productos
          </p>
        </div>

        {/* Filtros y Búsqueda */}
        <div className="max-w-6xl mx-auto mb-8">
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex flex-col md:flex-row gap-4 items-center">
              {/* Búsqueda */}
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Buscar recetas o ingredientes..."
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                />
              </div>

              {/* Filtro de categorías */}
              <div className="flex items-center gap-2">
                <Filter className="text-gray-500 w-5 h-5" />
                <select
                  value={filtroCategoria}
                  onChange={(e) => setFiltroCategoria(e.target.value)}
                  className="px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  {categorias.map(categoria => (
                    <option key={categoria} value={categoria}>{categoria}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Grid de Recetas */}
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {recetasFiltradas.map(receta => (
              <div
                key={receta.id}
                onClick={() => setRecetaSeleccionada(receta.id)}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              >
                <div className="p-0">
                  <img src={receta.imagenSrc} alt={receta.nombre} className="w-full h-40 object-cover rounded-t-2xl shadow mb-0" />
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <span className="flex items-center gap-1 text-yellow-500">
                        <Star className="w-4 h-4 fill-current" />
                        <span className="text-sm font-medium text-gray-700">{receta.rating}</span>
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{receta.nombre}</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
                      <span className="flex items-center gap-1">
                        <Clock className="w-4 h-4" />
                        {receta.tiempo}
                      </span>
                      <span className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        {receta.porciones}
                      </span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm font-medium">
                        {receta.categoria}
                      </span>
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${getDificultadColor(receta.dificultad)}`}>
                        {receta.dificultad}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {recetasFiltradas.length === 0 && (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">🔍</div>
              <p className="text-xl text-gray-600">No se encontraron recetas</p>
              <p className="text-gray-500">Intenta con otros términos de búsqueda</p>
            </div>
          )}
        </div>

        {/* Footer informativo */}
        <div className="max-w-4xl mx-auto mt-12 text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              🌟 Productos Premium Utilizados
            </h2>
            <p className="text-gray-600 mb-4">
              Todas nuestras recetas están diseñadas para aprovechar al máximo la calidad excepcional 
              de nuestros productos empaquetados con tecnología avanzada.
            </p>
            <div className="flex flex-wrap justify-center gap-2">
              {['Almendras Premium', 'Arándanos Orgánicos', 'Canela Gourmet', 'Chile de Árbol', 
                'Ciruela Pasa Premium', 'Frutos Secos Mix', 'Granola Casera', 'Flor de Jamaica', 
                'Nueces Selectas', 'Uva Pasa Selecta'].map(producto => (
                <span key={producto} className="px-3 py-1 bg-gradient-to-r from-orange-100 to-red-100 text-orange-800 rounded-full text-sm">
                  {producto}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecetarioGourmet;